var map = {
	"./Pienomial.png": "3374",
	"./Wynum.png": "217e2",
	"./background1.png": "cab4",
	"./bar.png": "ad2f",
	"./bottom.png": "e8a4",
	"./box_plot.png": "acec",
	"./candlestic.png": "44b6",
	"./chat-bg.png": "63a0",
	"./chat.png": "e306",
	"./chat1.png": "ce73",
	"./form.png": "4dc7",
	"./form1.png": "9eae",
	"./gar.png": "7cc7",
	"./histogram.png": "178a",
	"./home.png": "fbf5",
	"./icon-deviation.png": "3b4d",
	"./icon-deviation@2x.png": "9569",
	"./icon-discussion.png": "707d",
	"./icon-notification.png": "c2d3",
	"./line.png": "aa06",
	"./login.png": "07a6",
	"./menu.png": "2c36",
	"./pie.png": "411d",
	"./pienomial.png": "5104",
	"./rectangle_1218_copy_2.png": "a218",
	"./shape_1326.png": "7e17",
	"./shape_1329.png": "4c24",
	"./step.png": "d3b2",
	"./v1.png": "37f9",
	"./wynum-header.png": "207d",
	"./wynum.png": "8198"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9142";